<template>
  <div class="header">
    <router-link class="logo" :to="{ name: 'home' }">{{ $t('c.header.serviceName') }}</router-link>

    <div class="account">
      <div class="account__avatar"></div>

      <span class="account__name">{{ accountName }}</span>

      <div class="account__actions">
        <v-button theme="danger" view="transparent" @click="logout">{{ $t('c.header.logout')}}</v-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as type from '@/store/types'

export default {
  name: 'TheHeader',

  computed: {
    accountName() {
      return (
        this.$store.state[type.SESSION].model.user.directLogin || 'Direct login'
      )
    }
  },

  methods: {
    logout() {
      this.$store
        .dispatch(type.REMOVE_SESSION)
        .then(() => this.$router.push({ name: 'home' }))
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/style/scss/vars";
@import "../assets/style/scss/extends";

$avatar-width: 40px;
$avatar-height: $avatar-width;

.header {
  @extend %flex-row;
  justify-content: space-between;
  align-items: center;

  position: fixed;
  z-index: 2000; // на 1 больше, чем у loader
  top: 0;
  width: 100%;
  height: $header-height-base;
  padding: 0 $padding-base * 2.5;

  background-color: $white;
  box-shadow: $shadow-base;
  box-sizing: border-box;
}

.logo {
  color: $font-dark-base;
  font-family: $font-mono;
  font-weight: map-get($font-weight, "bold");
  font-size: 22px;

  &:hover,
  &:focus {
    color: rgba($font-dark-base, 20);
  }
  &:active {
    color: lighten($font-dark-base, 20);
  }
}

.account {
  @extend %flex-row;

  align-items: center;

  > * {
    &:not(:last-child) {
      margin-right: 1em;
    }
  }
}
.account__avatar {
  width: $avatar-width;
  height: $avatar-height;
  background-color: rgba($blueberry, 0.5);
  border-radius: 100%;
}
.account__name {
  color: $blueberry;
}
//\ account
</style>
